import { render, staticRenderFns } from "./classItem.vue?vue&type=template&id=1aee51ce&scoped=true&"
import script from "./classItem.vue?vue&type=script&lang=js&"
export * from "./classItem.vue?vue&type=script&lang=js&"
import style0 from "./classItem.vue?vue&type=style&index=0&id=1aee51ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aee51ce",
  null
  
)

export default component.exports